import { ReportFilterService } from "./../../report/models/report-filter.service";
import { VehicleService } from "./../../vehicle/models/vehicle.service";
import { FlatPickrDirective } from "./../../plugins/flatpickr/flatpickr.directive";
import { FlatPickrModel } from "./../../plugins/flatpickr/flatpickr.model";
import { TranslateService } from "./../../shared/translate/translate.service";
import { TripDataReportService } from "./../models/tripdatareport.service";
import { TripDataReportModel } from "./../models/tripdatareport.model";
import { InstanceService } from "../../instance/models/instance.service";
import { CompanyService } from "../../company/models/company.service";
import { SharedVehicleGroupService } from "./../../sharedvehiclegroup/models/sharedvehiclegroup.service";
import { AuthService } from "./../../shared/models/auth.service";
import { Component, OnInit, ViewChild } from "@angular/core";
import { NgForm } from "@angular/forms";
import { Observable } from "rxjs/Observable";
import { Router } from "@angular/router";
import {
  WeGoConfig,
  IAPIResponse,
  ApplicationRouteURL,
  DataListModel,
  RoleLevel
} from "../../shared/config";
import { DropdownModel } from "../../report/models/report-filter.model";
import { OrganizationService } from "../../organization/models/organization.service";
import { TripCommentService } from '../models/tripcomment.service';

const moment = require("moment");

@Component({
  selector: "wego-tripdatareport",
  template: require('../views/tripdatareport.component.html'),
  providers: [
    TripDataReportService,
    InstanceService,
    CompanyService,
    SharedVehicleGroupService,
    OrganizationService,
    VehicleService,
    ReportFilterService,
    TripCommentService
  ],
  styles: [
    `
          .box-body{
            padding: 0px 10px 10px;
          }
          .checkbox-inline{
            padding-left: 0px !important;
          }
          .box-body{
            padding:10px 10px 10px 10px;
          }
          .search
          {
            margin-top:5px;
          }
          `
  ]
})
export class TripDataReportComponent implements OnInit {
  @ViewChild("flatPickrConfigFromDate")
  public flatPickrConfigFromDate: FlatPickrDirective;
  @ViewChild("flatPickrConfigToDate")
  public flatPickrConfigToDate: FlatPickrDirective;

  @ViewChild("tripCommentModal") public tripCommentModal: any;

  public dateFormat: string = WeGoConfig.FLATPICKR_DATE_TIME_FORMAT;
  apiResponse: IAPIResponse;
  DataListModel: DataListModel;
  tripDatalList: TripDataReportModel[];
  model: TripDataReportModel;
  message: string;
  apiErrorMsg: string;
  isLoading: boolean;
  urlDefaultPage: string;
  deleteMessage: string;
  errorMessage: string;
  reportName: string;
  flatPickrConfigFrom: FlatPickrModel;
  flatPickrConfigTo: FlatPickrModel;
  errorModel: any;
  isInit: boolean = true;
  instanceList: DropdownModel[];
  companyList: DropdownModel[];
  sharedVehicleGroupList: DropdownModel[];
  driverVehicleList: any;
  public listOfFilterRecord: any[];
  itemPerPageList: any;
  driverList: DropdownModel[];
  vehicleList: DropdownModel[];
  private popupMsg: string;
  private module: string;
  private breadCrumbList: string;
  isExport: boolean = false;
  roleLevel = RoleLevel;
  organizationList: DropdownModel[];

  constructor(
    private tripdatareportservice: TripDataReportService,
    private translate: TranslateService,
    private authService: AuthService,
    private organizationService: OrganizationService,
    private instanceService: InstanceService,
    private companyService: CompanyService,
    private reportFilterService: ReportFilterService,
    private vehicleService: VehicleService,
    private sharedVehicleGroupService: SharedVehicleGroupService,
    private router: Router,
    private tripCommentService: TripCommentService
  ) {}

  ngOnInit() {
    this.reportName = "TripData_Report";
    this.itemPerPageList = WeGoConfig.GRID_PAGGING;
    this.ResetPaging();
    this.DataListModel = new DataListModel();
    this.module = this.translate.instant("LblTripDetailReport");
    this.model = new TripDataReportModel();
    // this.model.startDateTime = moment().add(-2, 'M').format('DD-MM-YYYY HH:mm');
    // this.model.endDateTime = moment().format('DD-MM-YYYY HH:mm');
    this.flatPickrConfigFrom = this.SetDefaultFlatPickrConfig();
    this.flatPickrConfigTo = this.SetDefaultFlatPickrConfig();
    this.flatPickrConfigTo.defaultDate = "23:59";
    
    this.urlDefaultPage = this.authService.GetURL(
      ApplicationRouteURL.URL_DEFAULT_PAGE
    );
    this.InitReportFilter();
  }

  private SetDefaultFlatPickrConfig() {
    let flatPickrConfig = new FlatPickrModel();
    flatPickrConfig.enableTime = true;
    flatPickrConfig.time_24hr = true;
    flatPickrConfig.dateFormat = this.dateFormat;
    flatPickrConfig.minuteIncrement = 1;
    return flatPickrConfig;
  }

  public OnFromDateChange(value: string) {
    if (value) {
      let format = "DD-MM-YYYY HH:mm";
      let newDate = moment(value, format).toDate();
      let endDate = moment(this.model.endDateTime, format).toDate();
      if (endDate < newDate) {
        let endDateVal = moment(value, format).add("H", 1);
        this.flatPickrConfigToDate.ChangeValue(
          endDateVal.format("DD-MM-YYYY HH:mm")
        );
      }
      this.flatPickrConfigToDate.SetOption("minDate", newDate);
    }
  }

  public OnPagingChange(event: any) {
    this.DataListModel.currentPage = 1;
    this.DataListModel.itemsPerPage = event;
    this.FilterList();
  }

  public OnPageChanged(event: any): void {
    this.DataListModel.currentPage = event.page;
    this.FilterList();
  }

  public FilterList() {
    let start =
      this.DataListModel.itemsPerPage * (this.DataListModel.currentPage - 1);
    let end = start + this.DataListModel.itemsPerPage;
    this.listOfFilterRecord = this.tripDatalList.slice(start, end);
  }

  public ResetPaging() {
    this.tripDatalList = [];
    this.listOfFilterRecord = [];
    this.DataListModel = new DataListModel();
    this.DataListModel.itemsPerPage = 10;
  }
  private OnSearchTrips() {
    this.isLoading = true;
    this.tripdatareportservice.GetTripData(this.model).subscribe(
      (res: any) => {
        if (!res.data) {
          this.errorModel = res.error;
          this.isLoading = false;
          this.isExport = false;
        } else {
          this.errorModel = null;
          this.tripDatalList = res.data;
          this.DataListModel.totalItems = res.data.length;
          this.DataListModel.infoMessage = res.error;
          this.FilterList();
          this.isExport = true;
        }
        this.isLoading = false;
      },
      error => {
        this.errorMessage = this.authService.HandleErrorStatusCode(error);
        this.isLoading = false;
      }
    );
  }
  public InitReportFilter() {
    this.GetAllInstanceList(); 
  }
  public GetAllInstanceList() {
    this.instanceService.GetDropdownInstanceList(this.reportName).subscribe(
      res => {
        this.instanceList = res.data;
        if (this.instanceList && this.instanceList.length > 0) {
          if (!this.model.instanceHashId && this.instanceList.length == 1) {
            this.model.instanceHashId = this.instanceList[0].keyHash;
          }
          this.onInstanceChange();
        }
      },
      error => {
        this.apiErrorMsg = this.authService.HandleErrorStatusCode(error);
      }
    );
  }
  public GetAllCompanyList() {
    this.companyService
      .GetDropdownCompanyList(this.reportName, this.model.instanceHashId)
      .subscribe(
        res => {
          this.companyList = res.data;

          if (this.companyList && this.companyList.length > 0) {
            // if (!this.model.companyHashId && this.companyList.length == 1) {
            //   this.model.companyHashId = this.companyList[0].keyHash;
            // }
            this.OnCompanyChange();
          }
        },
        error => {
          this.apiErrorMsg = this.authService.HandleErrorStatusCode(error);
        }
      );
  }
  public GetCompanyByInstance(instanceHashId?: string) {
    this.isLoading = true;
    this.companyService.GetCompanybyInstance(instanceHashId).subscribe(
      res => {
        this.companyList = res.data;
        this.isLoading = false;
      },
      error => {
        this.apiErrorMsg = this.authService.HandleErrorStatusCode(error);
        this.isLoading = false;
      }
    );
  }
  public GetAllSVGList() {
    //this.reportFilterService.GetSharedVehicleGroupList(null, companyHashId, null, instanceHashId)
    this.sharedVehicleGroupService
      .GetDropdownSVGList(
        this.reportName,
        this.model.companyHashId,
        this.model.instanceHashId
      )
      .subscribe(
        res => {
          this.sharedVehicleGroupList = res.data;
        },
        error => {
          this.apiErrorMsg = this.authService.HandleErrorStatusCode(error);
        }
      );
  }
  public GetVehicleBySVG() {
    // instanceHashId: string, companyHashId: string, sVGHashId: string
    //let company = sVGHashId != "" ? "" : companyHashId;
    //this.vehicleService.GetVehicleList(null, company, sVGHashId, instanceHashId)
    this.vehicleService
      .GetDropdownVehicleList(
        this.reportName,
        this.model.instanceHashId,
        this.model.companyHashId,
        this.model.sharedVehicleGroupHashId
      )
      .subscribe(
        res => {
          this.vehicleList = res.data;
        },
        error => {
          this.apiErrorMsg = this.authService.HandleErrorStatusCode(error);
        }
      );
  }
  public GetGroupDriverList() {
    this.isLoading = true;
    this.sharedVehicleGroupService
      .GetDropdownDriverList(
        this.model.sharedVehicleGroupHashId,
        this.model.organizationHashId,
        this.model.instanceHashId,
        this.model.companyHashId,
        null
      )
      .subscribe(
        res => {
          this.driverList = res.data;
          if (
            res.data == undefined ||
            res.data == null ||
            res.data.length == 0
          ) {
            this.model.driverHashId = "";
          }
          this.isLoading = false;
        },
        error => {
          this.errorMessage = this.authService.HandleErrorStatusCode(error);
          this.isLoading = false;
        }
      );
  }
  private GetVehicleForGroup() {
    this.isLoading = true;
    //this.sharedVehicleGroupService.GetSVGVehicleList(this.model.sharedVehicleGroupHashId)
    this.vehicleService
      .GetDropdownVehicleList(
        this.reportName,
        this.model.instanceHashId,
        this.model.companyHashId,
        this.model.sharedVehicleGroupHashId
      )
      .subscribe(
        res => {
          this.vehicleList = res.data;
          this.isLoading = false;
        },
        error => {
          this.apiErrorMsg = this.authService.HandleErrorStatusCode(error);
          this.isLoading = false;
        }
      );
  }
  public onInstanceChange() {
    this.isExport = false;
    this.companyList = null;
    this.sharedVehicleGroupList = null;
    this.organizationList = null;
    this.vehicleList = null;
    this.driverList = null;
    this.model.companyHashId = "";
    this.model.sharedVehicleGroupHashId = "";
    this.model.driverHashId = "";
    this.model.vehicleHashId = "";
    if (this.model.instanceHashId) {
      //this.GetCompanyByInstance(this.model.instanceHashId);
      this.GetAllCompanyList();
      this.model.companyHashId = "";
      //this.OnCompanyChange();
      //this.GetVehicleBySVG();
    } else {
      this.companyList = [];
      this.sharedVehicleGroupList = [];
      this.vehicleList = [];
      this.organizationList = [];
      this.model.companyHashId = "";
      this.model.sharedVehicleGroupHashId = "";
      this.model.vehicleHashId = "";
      this.model.organizationHashId = "";
    }
  }
  public OnCompanyChange() {
    this.ResetPaging();
    //this.GetAllSVGList(this.model.companyHashId, this.model.instanceHashId);
    this.GetAllSVGList();
    this.model.sharedVehicleGroupHashId = "";
    this.OnSVGChange();
  }
  public OnSVGChange() {
    this.ResetPaging();
    //this.GetVehicleBySVG(this.model.instanceHashId, this.model.companyHashId, this.model.sharedVehicleGroupHashId);
    this.model.organizationHashId = "";
    this.GetVehicleBySVG();
    this.GetGroupDriverList();
    this.model.vehicleHashId = "";
    
    this.GetSVGBaseOrganizationDropDown();
  }

public OnOrganizationChange()
{
  this.ResetPaging();
  this.GetGroupDriverList();
}


  public GetSVGBaseOrganizationDropDown() {
    // instanceHashId: string, companyMasterHashId: string, sVGHashId: string
    // let company = sVGHashId != "" ? "" : companyMasterHashId;
    this.organizationService
      .GetSVGBaseOrganizationDropDown(
        this.reportName,
        this.model.instanceHashId,
        this.model.companyHashId,
        this.model.sharedVehicleGroupHashId
      )
      .subscribe(
        res => {
          this.organizationList = res.data;
          if (this.organizationList && this.organizationList.length > 0) {
            if (
              !this.model.organizationHashId &&
              this.organizationList.length == 1
            ) {
              this.model.organizationHashId = this.organizationList[0].keyHash;
            }
            //this.OnOrganizationChange();
          }
        },
        error => {
          this.apiErrorMsg = this.authService.HandleErrorStatusCode(error);
        }
      );
  }

 
  public onVehicleChange(selectedVehicle: any) {
    this.isExport = false;
    this.model.vehicleHashId = selectedVehicle;
    this.ResetPaging();
  }
  public onDriverChange(selectedDriver: any) {
    this.isExport = false;
    this.model.driverHashId = selectedDriver;
    this.ResetPaging();
  }
  public OnSearchChange() {
    this.isExport = false;
    this.ResetPaging();
  }
  public OnFromDateChanged() {
    this.isExport = false;
    this.ResetPaging();
  }
  public OnToDateChange() {
    this.isExport = false;
    this.ResetPaging();
  }
  public OnExportPdf(event: any) {
    this.isLoading = true;
    this.tripdatareportservice.ExportTripDataReportPDF(this.model).subscribe(
      (res: any) => {
        if (res && res._body) {
          let fileName = "TripDataReport" + new Date().toISOString() + ".pdf";
          this.authService.DownloadFile(fileName, res._body);
        }
        this.isLoading = false;
      },
      (error: any) => {
        this.apiErrorMsg = this.authService.HandleErrorStatusCode(error);
        this.isLoading = false;
      }
    );
  }
  public OnExportExcel() {
    this.isLoading = true;
    this.tripdatareportservice.ExportTripDataReportCsv(this.model).subscribe(
      (res: any) => {
        if (res && res._body) {
          let fileName = "TripData" + new Date().toISOString() + ".xlsx";
          this.authService.DownloadXlsFile(fileName, res._body);
        }
        this.isLoading = false;
      },
      (error: any) => {
        this.apiErrorMsg = this.authService.HandleErrorStatusCode(error);
        this.isLoading = false;
      }
    );
  }

  public TripComment(TripId: string) {
    this.tripCommentService.GetTripComment(TripId)
      .subscribe(
      (res: any) => {
        this.tripCommentModal.model.tripId = TripId;
        this.tripCommentModal.model.tripComment = res.tripComment;
        this.tripCommentModal.model.tripCommentBy = res.tripCommentBy;
        this.tripCommentModal.model.tripCommentByFullname = res.tripCommentByFullname;
        this.tripCommentModal.model.tripCommentOn = res.tripCommentOn;
        this.isLoading = false;
      },
      (error: any) => {
        this.tripCommentModal.errorMsg = this.authService.HandleErrorStatusCode(error);
        this.isLoading = false;        
      });
      this.tripCommentModal.show();
  }  

}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/tripdatareport/components/tripdatareport.component.ts